import { useEffect } from 'react';
import { API } from '../../config';

export default function CourierLocationTracker() {
  useEffect(() => {
    const token = localStorage.getItem('token');

    // NEW:
    const trackingEnabled =
      localStorage.getItem('liveTrackingEnabled') === 'true';

    if (!navigator.geolocation || !token || !trackingEnabled) {
      return;
    }

    const send = (pos) => {
      const { latitude: lat, longitude: lng, accuracy } = pos.coords;

      fetch(`${API}/api/couriers/location`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          lat,
          lng,
          accuracy,
        }),
      }).catch(() => {});
    };

    const id = navigator.geolocation.watchPosition(
      send,
      () => {},
      {
        enableHighAccuracy: true,
        maximumAge: 5000,
        timeout: 15000,
      }
    );

    return () => navigator.geolocation.clearWatch(id);
  }, []);

  return null;
}